import React, { createContext, useContext, useState, useMemo } from 'react';
import Translator from '../utils/Translator';

const TranslationContext = createContext();

export function TranslationProvider({ children }) {
  const [language, setLanguage] = useState('EN'); // Default to English
  
  const translator = useMemo(() => {
    return new Translator(language);
  }, [language]);

  const value = {
    translator,
    language,
    setLanguage,
    getString: (key) => translator.getString(key)
  };

  return (
    <TranslationContext.Provider value={value}>
      {children}
    </TranslationContext.Provider>
  );
}

export function useTranslation() {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error('useTranslation must be used within a TranslationProvider');
  }
  return context;
} 